(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define(
      'cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');

          this.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
            const closer = event.target.closest('[data-drawer-close]');
            if (closer) this.dialog.close();
            const qty = event.target.closest('[data-line][data-quantity]');
            if (qty) this.changeLine(qty.dataset.line, qty.dataset.quantity);
          });

          window.addEventListener('cart:added', () => {
            this.refresh().then(() => this.open());
          });

          const headerCart = document.querySelector('.header__cart');
          if (headerCart) {
            headerCart.addEventListener('click', (event) => {
              event.preventDefault();
              this.refresh().then(() => this.open());
            });
          }
        }

        open() {
          if (!this.dialog.open) {
            this.dialog.showModal();
            // focus the body (tabindex=-1), not the × — no UA focus ring on
            // the close cross (the boxed-cross "carré").
            const body = this.dialog.querySelector('[data-drawer-body]');
            if (body) body.focus();
          }
        }

        get rootPath() {
          return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        }

        changeLine(line, quantity) {
          fetch(this.rootPath + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
          })
            .then(() => this.refresh())
            .catch(() => {});
        }

        refresh() {
          return fetch(this.rootPath + '?sections=cart-drawer')
            .then((response) => response.json())
            .then((sections) => {
              const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              const fresh = html.querySelector('[data-drawer-body]');
              const current = this.querySelector('[data-drawer-body]');
              if (fresh && current) {
                current.replaceWith(fresh);
                const count = fresh.dataset.itemCount;
                document.querySelectorAll('[data-cart-count]').forEach((el) => {
                  el.textContent = count;
                  el.hidden = count === '0';
                });
                // A qty change replaces the whole body, destroying the button
                // that had focus — that drops keyboard focus OUT of the modal
                // (it lands on <body>, and the next Tab escapes the dialog).
                // While the dialog is open, pull focus back into it: the body
                // (tabindex=-1) is always present and never paints a ring.
                if (this.dialog.open) fresh.focus();
              }
            })
            .catch(() => {});
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claims-band"]) return;
  try {
    
  /* Gate the marquee: only animate while the band is actually on screen, so
     the compositor layer isn't kept alive site-wide once you scroll past it
     (the band is near the very top, so it leaves the viewport almost
     immediately). Pure progressive enhancement — JS-off keeps the CSS loop
     running, and under reduced motion the animation is already `none`, so a
     pause class is a harmless no-op. */
  (() => {
    if (window.__sqmClaimsBand) return;
    window.__sqmClaimsBand = true;
    if (!('IntersectionObserver' in window)) return;
    const init = () => {
      document.querySelectorAll('.claims-band__track').forEach((track) => {
        if (track.dataset.sqmGated) return;
        track.dataset.sqmGated = '1';
        const band = track.closest('.claims-band') || track;
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            track.classList.toggle('is-paused', !entry.isIntersecting);
          });
        }, { threshold: 0 }).observe(band);
      });
    };
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
    /* re-gate when the section reloads in the theme editor */
    document.addEventListener('shopify:section:load', init);
  })();

  /* EU coming-soon notice: the EU market is DISABLED, so Liquid cannot see an
     EU visitor (their localization falls back to the primary market = CH and
     the band would promise them Swiss shipping terms). Country comes from
     SHOPIFY'S OWN IP geolocation — /browsing_context_suggestions.json, the
     same-origin endpoint behind Shopify's official Geolocation app — so no
     third-party call and the IP never leaves the platform (the detected code
     is kept in sessionStorage: one lookup per visit, functional only). On an
     EU-27 country, swap the free-shipping line for the coming-soon message in
     both marquee groups (equal width change keeps the -50% loop seamless).
     JS-off keeps today's behaviour. Test from anywhere with ?eu=1. Retire the
     setting once the EU market reopens. */
  (() => {
    const EU = [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
      'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
      'SI', 'ES', 'SE',
    ];
    const swap = () => {
      const band = document.querySelector('.claims-band[data-eu-coming]');
      if (!band) return;
      const msg = band.getAttribute('data-eu-coming');
      const notes = band.querySelectorAll('[data-ship-note]');
      if (notes.length) {
        notes.forEach((n) => {
          n.textContent = msg;
        });
      } else {
        band.querySelectorAll('.claims-band__group').forEach((g) => {
          const s = document.createElement('span');
          s.className = 'claims-band__item claims-band__item--offer';
          s.textContent = msg;
          g.appendChild(s);
        });
      }
    };
    const run = () => {
      if (!document.querySelector('.claims-band[data-eu-coming]')) return;
      if (/[?&]eu=1\b/.test(location.search)) return swap();
      let cached = null;
      try {
        cached = sessionStorage.getItem('sqm-geo');
      } catch (e) {
        /* Safari private mode: no cache, fetch each page */
      }
      if (cached) {
        if (EU.includes(cached)) swap();
        return;
      }
      fetch('/browsing_context_suggestions.json')
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const cc =
            (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || '';
          if (cc) {
            try {
              sessionStorage.setItem('sqm-geo', cc);
            } catch (e) {
              /* no-op */
            }
          }
          if (EU.includes(cc)) swap();
        })
        .catch(() => {});
    };
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', run)
      : run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["front-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__sqmHomeMix2) return;
    window.__sqmHomeMix2 = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = () => {
      const home = document.querySelector('.home');
      if (home) home.classList.add('front-grid--js'); // unhides per-card touch flip arrows

      // HERO (editorial split): every VISIBLE column cross-fades at the SAME
      // pace; the desktop right column ('b') runs on an ALTERNATING phase (it
      // flips halfway between the left's flips). Mobile drives its one column.
      // Each <img> carries data-hero-i scoped to its own seq, so one query
      // never mixes the three counts; display:none columns are skipped.
      document.querySelectorAll('[data-hero]').forEach((hero) => {
        const DUR = window.matchMedia('(max-width: 899px)').matches ? 2200 : 4200; // faster on mobile (Mattia), calmer on the desktop 3-set row
        const seqs = {};
        const build = (seq, phase) => {
          const imgs = Array.from(seq.querySelectorAll('.home-hero__img'));
          if (imgs.length < 2) return null;
          const o = { imgs, phase, timer: null, kick: null, i: Math.max(0, imgs.findIndex((el) => el.classList.contains('is-on'))) };
          o.light = (n) => {
            const prev = o.i; // the frame currently shown stays SOLID underneath
            o.i = (n + imgs.length) % imgs.length;
            imgs.forEach((el) => {
              const idx = el.dataset.heroI;
              if (idx === String(o.i)) { el.classList.add('is-on'); el.classList.remove('is-prev'); }
              else if (idx === String(prev) && prev !== o.i) { el.classList.add('is-prev'); el.classList.remove('is-on'); }
              else { el.classList.remove('is-on'); el.classList.remove('is-prev'); }
            });
            // decode the NEXT frame ahead of its turn → it's ready before it
            // fades in (no decode-flash on the first pass, esp. mobile)
            const nx = imgs[(o.i + 1) % imgs.length];
            if (nx && nx.decode) { try { nx.decode().catch(() => {}); } catch (e) { /* not loaded yet */ } }
          };
          return o;
        };
        hero.querySelectorAll('.home-hero__seq').forEach((seq) => {
          const key = seq.dataset.heroSeq;
          // stagger the 3 desktop sets by thirds so they never flip together
          var phase = ({ a: 0, b: DUR / 3, c: (DUR / 3) * 2, m: 0 })[key] || 0;
          const o = build(seq, phase);
          if (o) seqs[key] = o;
        });

        const visible = (key) => seqs[key] && seqs[key].imgs[0].offsetParent !== null;
        const stopOne = (o) => { if (o.timer) { clearInterval(o.timer); o.timer = null; } if (o.kick) { clearTimeout(o.kick); o.kick = null; } };
        const runOne = (o) => {
          if (reduce || o.timer || o.kick) return;
          const begin = () => { o.kick = null; o.timer = setInterval(() => o.light(o.i + 1), DUR); };
          o.phase ? (o.kick = setTimeout(begin, o.phase)) : begin();
        };
        const startAll = () => Object.keys(seqs).forEach((k) => { if (visible(k)) runOne(seqs[k]); });
        const stopAll = () => Object.keys(seqs).forEach((k) => stopOne(seqs[k]));
        const restart = () => { stopAll(); startAll(); };

        new IntersectionObserver(
          (es) => es.forEach((e) => (e.isIntersecting ? startAll() : stopAll())),
          { threshold: 0.15 }
        ).observe(hero);
        // crossing the breakpoint changes which columns are visible
        let rt = null;
        window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(restart, 200); });

        // arrows: each cluster steps ITS OWN column, then resets that timer
        const stepKey = (key, d) => {
          const o = seqs[key];
          if (!o) return;
          o.light(o.i + d);
          stopOne(o);
          if (!reduce && visible(key)) o.timer = setInterval(() => o.light(o.i + 1), DUR);
        };
        // a button's key may list several sets ("abc") → step each; "m" → just mobile
        hero.querySelectorAll('[data-hero-prev]').forEach((b) => b.addEventListener('click', () => b.dataset.heroPrev.split('').forEach((k) => stepKey(k, -1))));
        hero.querySelectorAll('[data-hero-next]').forEach((b) => b.addEventListener('click', () => b.dataset.heroNext.split('').forEach((k) => stepKey(k, 1))));

        // SWIPE (mobile): a horizontal drag steps the mobile column. passive —
        // only horizontal swipes act, vertical scroll is never blocked.
        let hx = 0, hy = 0, hsw = false;
        hero.addEventListener('touchstart', (e) => { hsw = true; hx = e.touches[0].clientX; hy = e.touches[0].clientY; }, { passive: true });
        hero.addEventListener('touchend', (e) => {
          if (!hsw) return;
          hsw = false;
          const t = e.changedTouches[0];
          const dx = t.clientX - hx;
          const dy = t.clientY - hy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepKey('m', dx < 0 ? 1 : -1);
        }, { passive: true });
      });

      // set a card's flip state + sync its 2-dot indicator + the arrow
      const setFlip = (card, flipped) => {
        if (!card) return;
        if (flipped) card.setAttribute('data-card-flipped', '');
        else card.removeAttribute('data-card-flipped');
        const arrow = card.querySelector('[data-card-flip]');
        if (arrow) arrow.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        card.querySelectorAll('[data-card-dot]').forEach((dot) => {
          const isVerso = dot.getAttribute('data-card-dot') === 'verso';
          dot.setAttribute('aria-pressed', (isVerso === flipped) ? 'true' : 'false');
        });
      };

      // delegated: per-card size preview + strip arrows. The per-card
      // dot/flip TAPS are owned solely by assets/card-stories.js now (its
      // document click listener stop+resteps from the tapped face) — handling
      // them here too double-fired the toggle. (The size→href update and the
      // swipe handler below still call setFlip directly.)
      document.addEventListener('click', (e) => {
        const sizeBtn = e.target.closest('[data-card-size-set]');
        if (sizeBtn) {
          const card = sizeBtn.closest('.front-card');
          if (card) {
            card.setAttribute('data-card-size', sizeBtn.getAttribute('data-card-size-set'));
            // keep the product link on the size SHOWN, so opening the PDP
            // lands on that variant (not the default L). Fixes "tap XL → L".
            const vid = sizeBtn.getAttribute('data-variant-id');
            const base = card.getAttribute('data-href');
            if (vid && base) {
              card.querySelectorAll('a.front-card__media-link, a.front-card__title').forEach((a) => {
                a.href = base + '?variant=' + vid;
              });
            }
          }
          return;
        }
        const arr = e.target.closest('[data-rail-prev], [data-rail-next]');
        if (arr) {
          const rail = arr.closest('.home-strip').querySelector('[data-rail]');
          if (rail) rail.scrollBy({ left: (arr.hasAttribute('data-rail-next') ? 1 : -1) * rail.clientWidth * 0.8, behavior: 'smooth' });
        }
      });

      // horizontal touch-SWIPE on a card's media toggles the face. Touch
      // only: a horizontal swipe (|dx| > 30 AND |dx| > |dy|) flips the card
      // and updates its dots; a vertical drag scrolls the page untouched.
      // Scoped to the phone grid (max-width:749px) where the rail is a
      // static 2-up wall — on the wider touch rail a horizontal drag is the
      // rail's own scroll gesture, so we don't hijack it there.
      const swipeMQ = window.matchMedia('(hover: none) and (max-width: 749px)');
      let sx = 0, sy = 0, swCard = null;
      document.addEventListener('touchstart', (e) => {
        if (!swipeMQ.matches) { swCard = null; return; }
        const media = e.target.closest('.front-card__media');
        swCard = media ? media.closest('.front-card') : null;
        if (!swCard) return;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      document.addEventListener('touchend', (e) => {
        if (!swCard) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - sx;
        const dy = t.clientY - sy;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
          setFlip(swCard, !swCard.hasAttribute('data-card-flipped'));
        }
        swCard = null;
      }, { passive: true });

      // FLAGS capsule: live countdown to the deadline (days/hours/minutes).
      // Hidden if the setting is blank, unparseable, or already past.
      document.querySelectorAll('[data-capsule]').forEach((cap) => {
        const out = cap.querySelector('[data-capsule-countdown]');
        const raw = cap.getAttribute('data-capsule-deadline');
        if (!out || !raw) return;
        const target = Date.parse(raw);
        if (isNaN(target)) return;
        const tick = () => {
          const ms = target - Date.now();
          if (ms <= 0) { out.hidden = true; return false; }
          const d = Math.floor(ms / 86400000);
          const h = Math.floor((ms % 86400000) / 3600000);
          const m = Math.floor((ms % 3600000) / 60000);
          out.textContent = 'Ends in ' + d + 'd ' + h + 'h ' + m + 'm';
          out.hidden = false;
          return true;
        };
        if (tick()) setInterval(tick, 60000);
      });

      // The home cards' recto/verso auto-switch is now the CHARGING-BAR
      // controller in assets/card-stories.js (shared with the shop-all wall) —
      // each visible card cycles behind a PDP-style charging bar on an
      // irregular cadence. The old one-card-at-a-time idle flip was removed.
    };

    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('menu-drawer')) {
    customElements.define(
      'menu-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          // accordion toggle (+/−): expand/collapse a section's sub-list.
          // close on backdrop, the × button, or ANY link tap (so the #hash
          // links that filter the /collections wall in place also dismiss it).
          this.addEventListener('click', (event) => {
            const tog = event.target.closest('[data-menu-toggle]');
            if (tog) {
              event.preventDefault();
              const open = tog.getAttribute('aria-expanded') === 'true';
              tog.setAttribute('aria-expanded', open ? 'false' : 'true');
              // the + lives in a .menu-drawer__row now (not a direct sibling of
              // the sub) → find the sub-list within the section.
              const section = tog.closest('.menu-drawer__section');
              const sub = section ? section.querySelector('[data-menu-sub]') : null;
              if (sub) sub.hidden = open;
              return;
            }
            if (event.target === this.dialog) this.dialog.close();
            if (event.target.closest('[data-menu-close]')) this.dialog.close();
            if (event.target.closest('a')) this.dialog.close();
          });

          this.openers = document.querySelectorAll('[data-menu-open]');
          this.openers.forEach((btn) => {
            btn.addEventListener('click', (event) => {
              event.preventDefault();
              if (!this.dialog.open) {
                this.dialog.showModal();
                // focus the non-interactive inner box (not the × button) so no
                // engine paints a focus ring on the close cross (le carré).
                const inner = this.dialog.querySelector('.menu-drawer__inner');
                if (inner) inner.focus();
                btn.setAttribute('aria-expanded', 'true');
              }
            });
          });

          this.dialog.addEventListener('close', () => {
            this.openers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    customElements.define(
      'newsletter-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;
          // Theme editor: never auto-open. The Customize preview reloads
          // on every navigation and does NOT persist our localStorage
          // stamp, so the popup would re-appear on each page — reads as
          // "shows on every page change". On the live store the stamp
          // persists and it shows exactly once. (Verified in-engine.)
          if (window.Shopify && window.Shopify.designMode) return;
          this.storageKey = '3sqm:newsletter';

          this.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-popup-close]')) {
              this.dismiss();
            }
          });
          this.dialog.addEventListener('cancel', () => this.stamp('dismissed'));

          const posted = this.querySelector('[data-popup-success]');
          const errored = this.querySelector('[data-popup-error]');
          if (posted) {
            this.stamp('done');
            this.show();
            return;
          }
          if (errored) {
            this.show();
            return;
          }

          // test mode: every visit, short delay, storage ignored
          this.testing = this.hasAttribute('data-test');

          if (!this.testing) {
            const state = this.readState();
            if (state === 'done') return;
            if (state === 'dismissed') return;
          }

          const delay = this.testing ? 2000 : (Number(this.dataset.delay) || 14) * 1000;
          this.timer = window.setTimeout(() => this.open(), delay);

          if (window.matchMedia('(hover: hover)').matches) {
            this.exitHandler = (event) => {
              if (event.clientY <= 0) this.open();
            };
            document.addEventListener('mouseleave', this.exitHandler);
          }
        }

        open() {
          window.clearTimeout(this.timer);
          if (this.exitHandler) document.removeEventListener('mouseleave', this.exitHandler);
          if (!this.dialog.open && (this.testing || this.readState() === null)) this.show();
        }

        show() {
          // mark as seen the instant it appears: the popup shows ONCE ever
          // per browser, even if the visitor leaves without interacting.
          this.stamp('done');
          this.dialog.showModal();
          // focus the dialog itself, not its first button: engines that
          // ignore dialog-level autofocus draw their UA focus ring on the
          // close cross (it looked different per browser)
          this.dialog.focus();
          // the loop only spends bandwidth once the dialog is actually
          // on screen; reduced motion keeps the poster. iOS requires the
          // muted IDL PROPERTY (the attribute alone is not enough) for a
          // programmatic play without a user gesture.
          const video = this.dialog.querySelector('video');
          if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.muted = true;
            const playing = video.play();
            if (playing && playing.catch) playing.catch(() => {});
          }
        }

        dismiss() {
          this.stamp('dismissed');
          this.dialog.close();
        }

        stamp(value) {
          window.clearTimeout(this.timer);
          if (this.exitHandler) document.removeEventListener('mouseleave', this.exitHandler);
          try {
            window.localStorage.setItem(this.storageKey, JSON.stringify({ v: value, t: Date.now() }));
          } catch (error) {
            /* private mode: show-once-per-pageview is acceptable */
          }
        }

        readState() {
          try {
            const raw = window.localStorage.getItem(this.storageKey);
            // any stored stamp means it already appeared once on this
            // browser — show it ONE time ever, never again.
            return raw ? 'done' : null;
          } catch (error) {
            return null;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-minimal"]) return;
  try {
    
  (function () {
    function assemble(root) {
      var link = (root || document).querySelector('[data-contact-email]');
      if (!link) return;
      var user = link.getAttribute('data-eu');
      var domain = link.getAttribute('data-ed');
      if (!user || !domain) return;
      // Joined only at runtime — never present in the served HTML.
      var address = user + String.fromCharCode(64) + domain;
      link.setAttribute('href', 'mailto:' + address);
      var label = link.querySelector('[data-contact-fallback]');
      if (label) {
        label.textContent = address;
      } else {
        link.textContent = address;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        assemble(document);
      });
    } else {
      assemble(document);
    }

    // Re-assemble when the section is reloaded in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      assemble(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grid-density')) {
    customElements.define(
      'grid-density',
      class extends HTMLElement {
        connectedCallback() {
          // unhides the per-tile touch face controls (2-dot pager + the
          // quick-add basket) in towel-card (same gate as the home's
          // .front-grid--js). JS-off → no control shows.
          this.classList.add('product-grid--js');
          this.control = this.querySelector('[data-density-control]');
          if (this.control) {
            // Desktop arrives on ALL (the markup default). PHONES arrive on L
            // (Mattia, option 3 — "densité par défaut plus petite"). Set the
            // density BEFORE unhiding the switcher so it never paints showing
            // ALL then snap to L (the FOUC guard above already pinned the grid
            // itself; this keeps the switcher label in sync from first reveal).
            if (window.matchMedia('(max-width: 749px)').matches) this.set('l');
            this.control.hidden = false;
            this.control.addEventListener('click', (event) => {
              const button = event.target.closest('[data-density-set]');
              if (button) this.set(button.dataset.densitySet);
            });
          }
          this.initFlip();
          this.initFilter();
          this.initSpy();
          this.initStickyNav();
          this.initAutoHideNav();
        }

        // Per-tile face controls (touch, mobile wall): a horizontal swipe on
        // the tile media toggles/sets [data-card-flipped] on the tile's wrap →
        // recto/verso crossfade. The 2-dot pager TAPS are owned solely by
        // assets/card-stories.js now (its document click listener stop+resteps
        // from the tapped face) — handling them here too double-fired the
        // toggle. Reuses the two faces already in the DOM.
        initFlip() {
          // Horizontal touch-swipe on the tile media: swipe left → verso,
          // swipe right → recto. Touch only (pointerType check); desktop
          // hover crossfade is untouched. Bound to the wrap's media area.
          let startX = 0;
          let startY = 0;
          let tracking = false;
          this.addEventListener(
            'touchstart',
            (event) => {
              const wrap = event.target.closest('.towel-card-wrap');
              if (!wrap || !event.target.closest('.towel-card__media')) {
                tracking = false;
                return;
              }
              tracking = true;
              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
            },
            { passive: true }
          );
          this.addEventListener(
            'touchend',
            (event) => {
              if (!tracking) return;
              tracking = false;
              const wrap = event.target.closest('.towel-card-wrap');
              if (!wrap) return;
              const touch = event.changedTouches[0];
              const dx = touch.clientX - startX;
              const dy = touch.clientY - startY;
              // a real horizontal swipe: mostly sideways, past a threshold.
              // Below threshold = a tap → let the <a> navigate (no preventDefault).
              if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy)) return;
              event.preventDefault();
              this.setFace(wrap, dx < 0); // left → verso, right → recto
            },
            { passive: false }
          );
        }

        // Set a tile's face and sync its 2-dot pager aria-pressed.
        setFace(wrap, showVerso) {
          if (showVerso) {
            wrap.setAttribute('data-card-flipped', '');
          } else {
            wrap.removeAttribute('data-card-flipped');
          }
          wrap.querySelectorAll('[data-card-flip]').forEach((dot) => {
            const isThisFace = (dot.dataset.face === 'verso') === showVerso;
            dot.setAttribute('aria-pressed', isThisFace ? 'true' : 'false');
          });
        }

        // Scroll-spy: no titles in the grid — the index tells you where you
        // are (the collection in view goes bold; on the mobile sticky bar it
        // also auto-centres).
        initSpy() {
          const groups = this.querySelectorAll('.product-grid__group');
          if (!groups.length) return;
          // Anchor = each collection's FIRST TILE (the groups collapse to
          // display:contents on the desktop wall, so they have no rect; the
          // first tile sits at the collection's top on every viewport).
          const anchors = [];
          groups.forEach((group) => {
            const tile = group.querySelector('.towel-card-wrap, .towel-card');
            if (tile) anchors.push({ tile: tile, handle: group.id });
          });
          if (!anchors.length) return;
          const links = this.querySelectorAll('.product-grid__index-link[data-filter]');
          let currentHandle = null;
          // The active collection = the LAST one whose first tile has crossed a
          // line ~30% down the viewport, computed from SCROLL POSITION (not a
          // thin IO band). So EVERY collection lights up in turn as you scroll —
          // even where several short collections' first tiles share a row on the
          // dense desktop wall (the band approach skipped those: cyano→lidar).
          const update = () => {
            const lineY = window.innerHeight * 0.3;
            let activeHandle = '';
            for (let i = 0; i < anchors.length; i++) {
              if (anchors[i].tile.getBoundingClientRect().top <= lineY) activeHandle = anchors[i].handle;
              else break; // anchors are in vertical order → first miss = stop
            }
            if (activeHandle === currentHandle) return; // no DOM writes when unchanged
            currentHandle = activeHandle;
            let active = null;
            links.forEach((link) => {
              const on = link.dataset.filter === activeHandle;
              link.classList.toggle('is-current', on);
              if (on) active = link;
            });
            if (active) this.centerActive(active);
          };
          let ticking = false;
          const onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => { ticking = false; update(); });
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll, { passive: true });
          update();
        }

        // Auto-centre the active link inside the horizontally-scrollable
        // index. Sets scrollLeft directly (NOT scrollIntoView, which would
        // also scroll the page vertically and fight the user's scroll).
        // No-op unless the index actually overflows (the stuck black line).
        centerActive(link) {
          const nav = this.querySelector('.product-grid__index');
          if (!nav || nav.scrollWidth <= nav.clientWidth + 1) return;
          const target = link.offsetLeft - (nav.clientWidth - link.offsetWidth) / 2;
          const max = nav.scrollWidth - nav.clientWidth;
          nav.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'smooth' });
        }

        // Sticky nav (mobile): when the sentinel above the index scrolls out
        // the top, the index has pinned — flag it so CSS collapses it to one
        // black, centred, horizontally-scrollable scroll-spy line.
        initStickyNav() {
          const sentinel = this.querySelector('.product-grid__stick-sentinel');
          if (!sentinel || !('IntersectionObserver' in window)) return;
          const io = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                this.classList.toggle('is-nav-stuck', !entry.isIntersecting && entry.boundingClientRect.top < 0);
              }
            },
            { threshold: 0 }
          );
          io.observe(sentinel);
        }

        // VIEW switcher auto-hide (mobile, Mattia): hide on scroll DOWN, reveal
        // on scroll UP (and always near the top). The collection index line
        // stays pinned as the scroll-spy; only the VIEW row tucks away behind
        // it. rAF-throttled + passive so it never costs scroll smoothness; the
        // CSS that responds to [data-nav-hidden] is mobile-only, so this is a
        // no-op on desktop.
        initAutoHideNav() {
          let lastY = window.scrollY || 0;
          let ticking = false;
          const update = () => {
            ticking = false;
            const y = window.scrollY || 0;
            const delta = y - lastY;
            if (y < 120) {
              this.removeAttribute('data-nav-hidden');
            } else if (delta > 6) {
              this.setAttribute('data-nav-hidden', '');
            } else if (delta < -6) {
              this.removeAttribute('data-nav-hidden');
            }
            lastY = y;
          };
          window.addEventListener(
            'scroll',
            () => {
              if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
              }
            },
            { passive: true }
          );
        }

        // The collection index is a NAVIGATOR, not a filter. Clicking a
        // collection (or arriving on /collections#handle from the menu /
        // wall index) SMOOTH-SCROLLS to that collection group on the
        // single shop-all wall — there is no separate page, no heavy
        // filter/expand pass (that expand-everything-then-scrollIntoView
        // was the freeze). The scroll-spy keeps the index in sync; JS-off
        // keeps the native anchor jump (the links are real #handle anchors).
        initFilter() {
          const links = this.querySelectorAll('.product-grid__index-link[data-filter]');
          if (!links.length) return;
          links.forEach((link) => {
            link.addEventListener('click', (event) => {
              const handle = link.dataset.filter;
              // ALL (empty filter) → scroll to the top of the wall
              const target = handle ? this.querySelector('#' + CSS.escape(handle)) : this;
              if (!target) return; // unknown handle: let the native anchor do it
              event.preventDefault();
              this.scrollToGroup(target, handle);
            });
          });
          // arrival via #handle (menu drawer / wall index link on another
          // page): smooth-scroll to the group once, after layout settles.
          const initial = window.location.hash.replace('#', '');
          if (initial) {
            const target = this.querySelector('#' + CSS.escape(initial));
            if (target) {
              // rAF so the grid has laid out (avoids a 0px scroll target)
              requestAnimationFrame(() => this.scrollToGroup(target, initial));
            }
          }
        }

        // Smooth-scroll to a group and reflect it in the index + the URL.
        scrollToGroup(target, handle) {
          const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // the group collapses to display:contents on the desktop wall (no
          // rect) → scroll its FIRST TILE; on mobile/ALL the element has a box.
          let el = target;
          if (target !== this && target.getBoundingClientRect().height < 1) {
            el = target.querySelector('.towel-card-wrap, .towel-card') || target;
          }
          el.scrollIntoView({ behavior: motionOk ? 'smooth' : 'auto', block: 'start' });
          // bold the active link immediately (the spy will keep it current)
          let activeLink = null;
          this.querySelectorAll('.product-grid__index-link[data-filter]').forEach((link) => {
            const on = link.dataset.filter === handle;
            link.classList.toggle('is-current', on);
            if (on) activeLink = link;
          });
          if (activeLink) this.centerActive(activeLink);
          const hash = handle ? '#' + handle : window.location.pathname;
          window.history.replaceState(null, '', hash);
        }

        set(density) {
          if (!['all', 'm', 'l', 'xl'].includes(density)) return;
          this.dataset.density = density;
          this.control.querySelectorAll('[data-density-set]').forEach((button) => {
            button.setAttribute('aria-pressed', button.dataset.densitySet === density ? 'true' : 'false');
          });
        }
      }
    );
  }

  /* The wall tiles' recto/verso auto-switch is now the shared CHARGING-BAR
     controller in assets/card-stories.js — each visible tile cycles behind a
     PDP-style charging bar on an irregular cadence (mobile only, visible only).
     The old one-tile-at-a-time idle flip was removed. */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('variant-radios')) {
    customElements.define(
      'variant-radios',
      class extends HTMLElement {
        connectedCallback() {
          this.priceEl = document.getElementById(this.dataset.priceTarget);
          this.dimsEl = this.dataset.dimsTarget
            ? document.getElementById(this.dataset.dimsTarget)
            : null;
          // The dims display is two nodes (cm prominent, inch discreet) —
          // mirror each from the checked size's data-dims-cm / data-dims-in.
          this.dimsCmEl = this.dimsEl
            ? this.dimsEl.querySelector('[data-dims-cm]')
            : null;
          this.dimsInEl = this.dimsEl
            ? this.dimsEl.querySelector('[data-dims-in]')
            : null;
          this.addEventListener('change', (event) => {
            const radio = event.target;
            if (radio.name !== 'id') return;
            if (this.priceEl && radio.dataset.price) {
              this.priceEl.textContent = radio.dataset.price;
            }
            if (this.dimsCmEl && radio.dataset.dimsCm) {
              this.dimsCmEl.textContent = radio.dataset.dimsCm;
            }
            if (this.dimsInEl && radio.dataset.dimsIn) {
              this.dimsInEl.textContent = radio.dataset.dimsIn;
            }
            // Keep the CTA honest: a sold-out default must not leave the
            // button dead once an available size is picked (and vice versa).
            const form = this.closest('form');
            const addButton = form && form.querySelector('.product__add');
            if (addButton) {
              const available = !radio.disabled;
              addButton.disabled = !available;
              const label = available
                ? addButton.dataset.labelAdd
                : addButton.dataset.labelSoldOut;
              if (label) addButton.textContent = label;
            }
            // The gallery swipe is pure CSS (:has) — only the trio needs JS.
            const root = this.closest('product-media');
            const size = radio.dataset.size;
            if (!root || !size) return;
            root.querySelectorAll('.product__trio-item').forEach((item) => {
              item.classList.toggle('is-selected', item.dataset.size === size);
            });
          });
        }
      }
    );
  }

  if (!customElements.get('sticky-buy')) {
    customElements.define(
      'sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.priceEl = this.querySelector('[data-buybar-price]');
          this.sizeEl = this.querySelector('[data-buybar-size]');
          this.addButton = this.querySelector('.product__buybar-add');
          // Mirror price + size + sold-out from the form whenever the size
          // changes (the radios live in the same form). Initial state is
          // already server-rendered from the default variant.
          if (this.form) {
            this.form.addEventListener('change', (event) => {
              const radio = event.target;
              if (!radio || radio.name !== 'id') return;
              this.sync(radio);
            });
          }
          // Reveal the bar once the primary CTA leaves the viewport, hide it
          // again when it returns. No IntersectionObserver (very old engine):
          // leave the bar hidden — the main CTA is the fallback.
          const target = this.dataset.observe
            ? document.querySelector(this.dataset.observe)
            : null;
          if (target && 'IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  this.hidden = entry.isIntersecting;
                });
              },
              { rootMargin: '0px 0px -8% 0px' }
            );
            this.io.observe(target);
          }
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }

        sync(radio) {
          if (this.priceEl && radio.dataset.price) {
            this.priceEl.textContent = radio.dataset.price;
          }
          if (this.sizeEl && radio.dataset.size) {
            this.sizeEl.textContent = radio.dataset.size;
          }
          if (this.addButton) {
            const available = !radio.disabled;
            this.addButton.disabled = !available;
            const label = available
              ? this.addButton.dataset.labelAdd
              : this.addButton.dataset.labelSoldOut;
            if (label) this.addButton.textContent = label;
          }
        }
      }
    );
  }

  if (!customElements.get('product-media')) {
    customElements.define(
      'product-media',
      class extends HTMLElement {
        connectedCallback() {
          // Hovering OR tapping a face drives the trio — no buttons.
          this.addEventListener(
            'pointerenter',
            (event) => {
              if (!event.target || !event.target.closest) return;
              const source = event.target.closest('[data-face-source]');
              if (source) this.setFace(source.dataset.faceSource);
            },
            true
          );
          this.addEventListener('click', (event) => {
            if (!event.target || !event.target.closest) return;
            const source = event.target.closest('[data-face-source]');
            if (source) {
              this.setFace(source.dataset.faceSource);
              return;
            }
            // a mannequin in the trio selects its size, like the radios above
            const trioItem = event.target.closest('.product__trio-item');
            if (trioItem && trioItem.dataset.size) {
              const sel = (window.CSS && CSS.escape)
                ? CSS.escape(trioItem.dataset.size)
                : trioItem.dataset.size;
              const radio = this.querySelector('[data-size-input][data-size="' + sel + '"]');
              if (radio && !radio.checked && !radio.disabled) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
        }

        setFace(face) {
          if (face !== 'recto' && face !== 'verso') return;
          if (this.dataset.face === face) return;
          this.dataset.face = face;
          this.querySelectorAll('[data-face-img]').forEach((wrapper) => {
            wrapper.hidden = wrapper.dataset.faceImg !== face;
          });
        }
      }
    );
  }

  document.querySelectorAll('product-media form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.fetch) return;
      event.preventDefault();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // Disable BOTH add buttons (primary CTA + the mobile sticky-buy
      // button) while the request is in flight so a quick double-tap on
      // the bar can't fire two adds.
      const buttons = form.querySelectorAll('button[name="add"]');
      buttons.forEach((b) => {
        b.disabled = true;
      });
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((response) => {
          if (!response.ok) throw new Error('add-to-cart failed');
          window.dispatchEvent(new CustomEvent('cart:added'));
        })
        .catch(() => form.submit())
        .finally(() => {
          buttons.forEach((b) => {
            b.disabled = false;
          });
        });
    });
  });

  if (!customElements.get('product-share')) {
    customElements.define(
      'product-share',
      class extends HTMLElement {
        connectedCallback() {
          // Native share ONLY. If the engine has no Web Share API (most desktop
          // browsers), the control stays hidden — no copy-link fallback (Mattia).
          const btn = this.querySelector('[data-share-trigger]');
          if (!btn || typeof navigator.share !== 'function') return;
          this.hidden = false; // reveal now that we know the native sheet exists
          btn.addEventListener('click', () => {
            navigator.share({
              title: this.dataset.title || document.title,
              url: this.dataset.url || window.location.href
            }).catch(() => {}); // user dismissed / cancelled — no-op
          });
        }
      }
    );
  }

  // Back control: upgrade <a data-pdp-back> to history.back() ONLY when the
  // referrer is same-origin and there is history to go back to (so it returns
  // where the shopper came from). Otherwise the href fallback — the collection
  // wall — stands, keeping it safe for deep-links, new tabs and JS-off.
  document.addEventListener('click', function (e) {
    var back = e.target.closest('[data-pdp-back]');
    if (!back) return;
    try {
      var ref = document.referrer;
      if (ref && new URL(ref).origin === window.location.origin && window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    } catch (err) {
      /* fall through to the href */
    }
  });

  } catch(e) { console.error(e); }
})();
})();
